<template>
  <div class="ClientInput">
    <div class="title">{{ $props.title }}</div>
    <input type="text" :value=$props.value @input="(e)=>onChange(e.target.value)">
    <div v-if=$props.unit class="unit">{{ $props.unit }}</div>
  </div>
</template>

<script>
export default {
  name: "ClientInput",
  props: ["title", "unit", "value", "onChange"]
}
</script>

<style scoped lang="less">
.ClientInput {
  padding: 0 23px;
  font-size: 17px;
  color: #a2b4cf;
  line-height: 28px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  input {
    display: block;
    margin: 0 8px;
    width: 75px;
    height: 28px;
    line-height: 28px;
    border: solid 2px #a2b4cf;
    outline: none;
    font-size: 17px;
    color: #a2b4cf;
    text-align: center;
    padding: 0;
  }
}
</style>
